import React from "react";
import { useNavigate } from "react-router-dom";
import { TitleH1, TitleH3 } from "../../../../../../../shared/native/typography.styles";
import { PrimaryButton } from "../../../../../../../shared/native/button.styles";
import { Ul } from "../../../../../../../shared/native/ul.styles";
import { Li } from "../../../../../../../shared/native/li.styles";
import {
  InfoPage,
  InfoPageContent,
  InfoPageTextInfo,
} from "../../../../../../../shared/infoPage/infoPage.styles";
import { useAppDispatch, useAppSelector } from "../../../../../../../../core/hooks/redux";
import { setViewedStep } from "../../../../../../../../store/modules/applications/highEducation/highEducationSlice";
import { getApplicationsRequest } from "../../../../../../../../http/requests/applications/applications.http";
import { isOfflineDpoPayload } from "../../../../../../../../core/interfaces/applications/OfflineDpoPayload";
import Loader from "../../../../../../../shared/loaders/Loader";
import { OfflineInfoPageContent, OfflineInfoText } from "./addingDataInfo.styles";

const AddingDataInfo: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { additionalAEDataState } = useAppSelector((state) => state.modulesState.applicationsState);
  const [isOfflineDpo, setIsOfflineDpo] = React.useState<boolean | null>(null);

  React.useEffect(() => {
    getApplicationsRequest("additional").then((res) => {
      const offline = isOfflineDpoPayload(res.data.payload);
      setIsOfflineDpo(offline);

      if (offline) {
        return;
      }

      if (additionalAEDataState.employment?.position) {
        navigate("/applications/additional-ae-data/check");
        return;
      }

      if (additionalAEDataState.education?.educationLevel) {
        dispatch(setViewedStep(1));
        navigate("/applications/additional-ae-data/form");
      }
    });
  }, []);

  if (isOfflineDpo === null) {
    return (
      <InfoPage>
        <InfoPageContent>
          <Loader type="spinner" />
        </InfoPageContent>
      </InfoPage>
    );
  }

  if (isOfflineDpo) {
    return (
      <InfoPage>
        <OfflineInfoPageContent>
          <OfflineInfoText>
            <p>
              <strong className="strongWord">Дорогие слушатели!</strong> <br /> На данный момент на
              нашем сервере ведутся технические работы. Окончание запланировано на утро понедельника
              (03.08). Если у вас возникнут какие-либо вопросы, обращайтесь на почту Департамента
              дополнительного образования:{" "}
              <a className="linkWord" href="mailto:do@inpsycho.ru">
                do@inpsycho.ru
              </a>
              .
              <br />
              <br />
              <strong>Благодарим вас за терпение!</strong>
            </p>
          </OfflineInfoText>
        </OfflineInfoPageContent>
      </InfoPage>
    );
  }

  return (
    <InfoPage>
      <InfoPageContent>
        <InfoPageTextInfo>
          <TitleH1>Внесение дополнительных сведений</TitleH1>
          <p>
            Для подачи заявления на программу дополнительного образования, пожалуйста, внесите
            данные о предыдущем образовании и сведения о трудоустройстве.
          </p>
          <TitleH3>Что нужно для заполнения:</TitleH3>
          <Ul>
            <Li>Документ о ранее полученном образовании</Li>
          </Ul>
        </InfoPageTextInfo>
        <PrimaryButton onClick={(): void => navigate("/applications/additional-ae-data/form")}>
          Начать
        </PrimaryButton>
      </InfoPageContent>
    </InfoPage>
  );
};

export default AddingDataInfo;
